<template>
  <div class="about  app-bg">
    <div class="about-header">
      <p>多元化的风险管理及保险服务
        <br>保险经纪领域领跑者
      </p>
    </div>
    <v-container class="pa-0">
      <v-layout column>
        <v-flex align-self-center>
          <h2>北京易才简介</h2>
        </v-flex>
        <v-flex>
          <article>
            <p>
              北京易才，是一家专注金融、健康管理大数据、人工智能、物联网、区块链等时代前沿技术为基础服务金融、健康管理等新一代信息技术自主研发与应用创新的高科技企业。深度了解金融、保险、健康管理市场环境，为多家保险中介机构、健康管理机构开发、改造、协调核心系统，有效降低企业运营成本，改善用户体验和服务水平，提高经营效益。北京易才宏业管理顾问有限公司全资控股。北京易才宏业管理顾问有限公司下属多家人力资源管理公司，特别是北京易才人力资源顾问有限公司（是中国三大人力资源公司之一），已成为集团化公司，（简称：易才集团），集团下属人力资源公司服务网络覆盖全国超400座城市，服务雇员总数逾百万（截止到2019年12月末，全国服务30000多家企业，员工200多万），拥有出众的全国网点覆盖服务与民企百万级别服务能力。易才集团深耕人力资源行业16年中，始终秉持客户需求为导向，奉“以人为本，与企业、与社会共赢未来”为使命，依托辐射全国的服务网络、先进的互联网服务平台和强大的计算机技术支持，为客户提供商业保险、人事代理、劳务派遣、互联网升级产品应用等多层次、全方位、高效率的一站式人力资源服务。2016年人力资源和社会保障部劳动科学研究所联手易才成立“易才科研实践基地”，并在易才的北京、广州、成都等11个分支机构进行了挂牌，推进建设和谐劳动关系的新篇章。
            </p>
          </article>
        </v-flex>
      </v-layout>
      <!-- <v-layout column>
        <v-flex align-self-center>
          <h2>经营资质</h2>
        </v-flex>
        <v-flex shrink class="about-img">
          <v-layout justify-center wrap>
            <v-flex xs12 sm12 md6>
              <v-img  max-height="400px" contain
                     src="https://qihuibao.oss-cn-beijing.aliyuncs.com/company/new-insurance-licence.jpg"></v-img>
            </v-flex>
            <v-flex xs12 sm12 md6>
              <v-img  max-height="400px" contain
                     src="https://qihuibao.oss-cn-beijing.aliyuncs.com/company/new-business-license.png"></v-img>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout> -->
      <!-- <v-layout column>
        <v-flex align-self-center>
          <h2 class="contact hidden-sm-and-down" id="contact">联系方式</h2>
        </v-flex>
        <v-flex class="contact">
          <v-layout row wrap>
            <v-flex md3 sm12 xs12>
              <h3>联系方式</h3>
            </v-flex>
            <v-flex md9 sm12 xs12>
              <ul style="border-top:none;margin: 0;padding: 0;">
                <li>
                  <p>
                    <span>合作邮箱：</span>hezuo@chinatalentgroup.com
                  </p>
                </li>
                <li>
                  <p>
                    <span>投诉邮箱：</span>tousu@chinatalentgroup.com
                  </p>
                </li>
              </ul>
            </v-flex>
          </v-layout>
          <v-layout style="margin-top: 20px;"  row wrap>
            <v-flex  md3 sm12 xs12>
              <h3 style="padding-top: 20px;">办公室地址</h3>
            </v-flex>
            <v-flex  md9 sm12 xs12>
              <ul style="padding-top: 20px;">
                <li class="mb-3">
                  <p>天津总部地址：天津市河西区黑牛城道与洞庭路交口东南侧五福大厦-1-1407、-1-1408</p>
                  <p>联系电话：022-88325599</p>
                </li>
                <li class="mb-3">
                  <p>北京分公司地址：北京市朝阳区广渠路东路唐家村43幢一层28-B</p>
                  <p>联系电话：010-50947000</p>
                </li>
                <li class="mb-3">
                  <p>陕西分公司地址：陕西省西安市雁塔区融鑫路1号203室</p>
                  <p>联系电话：029-87360693</p>
                </li>
                <li class="mb-3">
                  <p>新疆分公司地址：新疆省乌鲁木齐市天山区光明路100号金碧华府1503室</p>
                  <p>联系电话：0991-8822023</p>
                </li>
                <li class="mb-3">
                  <p>甘肃分公司地址：甘肃省兰州市城关区闵家桥100号一楼049室</p>
                  <p>联系电话：0931-8187101</p>
                </li>
                <li class="mb-3">
                  <p>河北分公司地址：河北石家庄循环化工园区丘头镇十炼路北行50米北方物流招待中心4层</p>
                  <p>联系电话：0311-82956750</p>
                </li>
                <li class="mb-3">
                  <p>吉林分公司地址：长春市宽城区万龙台北明珠E1栋1310室</p>
                  <p>联系电话：0431-80549607</p>
                </li>
              </ul>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout> -->
    </v-container>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>
<style lang="scss">
@media only screen and (min-width: 1280px){
  .about{
    .container {
      max-width: 900px !important;
    }
  }
}
.about {
  h2 {
    font-size: 36px;
    font-weight: 400;
    margin-bottom: 40px;
    margin-top: 60px;
  }
}
article p {
  text-indent: 2em;
  font-size: 16px;
  color: #666;
}
.contact {
  margin-bottom: 80px;
  h3 {
    width: 125px;
    font-size: 24px;
    color: #666;
    margin-right: 122px;
  }
  ul {
    color: #666;
    font-size: 16px;
    border-top: 1px solid #e5e5e5;
    padding-left: 0;

    p {
      margin-bottom: 0;
    }

    span {
      display: inline-block;
      width: 80px;
    }
  }
}
.about-header {
  width: 100%;
  height: 377px;
  background: url("/images/about/about-bg.png") no-repeat center center;
  background-size: cover;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  p {
    font-size: 30px;
    font-weight: 500;
    color: #fff;
  }
}
@media screen and (max-width: 600px) {
  .about-header p{
    font-size:28px ;
  }
  .about {
    h2 {
      font-size: 26px;
      font-weight: 400;
      margin-bottom: 18px;
      margin-top: 50px;
    }
  }
  .contact{
    margin-top: 30px;
    h3{
      width: auto;
      text-align: center;
      margin-right: 0;
    }
    ul {
      color: #666;
      font-size: 16px;
      border-top:none;
      padding-left: 0;
    }
  }
  article,.about-img,.contact{
    padding: 0 15px;
  }
}
</style>